import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.bodyColor};
  background: ${props => props.theme.bodyBackgroundColor};

  ${props => (props.theme.isMobile ? `
    width: 100vw;
    max-height: calc(100vh - 135px);
    padding: 0 20px 60px 20px;
    flex-grow: 2;
  ` : `
    justify-content: space-between;
    padding: 36px 40px 36px 40px;
    border-radius: 10px;
    box-shadow: 0 2px 3px ${props.theme.darkShadowColor};
  `)}
`;

const ContainerAlt = styled(Container)`
  ${props => (props.theme.isMobile && `
    padding-bottom: 26px;
  `)}
`;

const Title = styled.span`
  max-width: 650px;
  margin-bottom: 18px;
  text-align: center;
  font: ${props => props.theme.fontWeightBold} 30px/39px ${props => props.theme.fontFamilyHeader};
`;

const Description = styled.p`
  margin-top: 0;
  text-align: center;
  font: ${props => props.theme.fontWeightBold} 16px/20px ${props => props.theme.fontFamilyBody};
  ${props => (!props.theme.isMobile && `
    width: 674px;
  `)}
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  ${props => (props.theme.isMobile ? `
    flex-direction: row;
    flex-wrap: wrap;
  ` : `
    flex-direction: row-reverse;
    justify-content: space-between;
  `)}
`;

const IButton = styled.button`
  text-transform: uppercase;
  font-size: 16px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  border: 0;
  background-color: transparent;
  ${props => (props.theme.isMobile && `
    margin-top: 15px;
  `)}
`;

const RightButton = styled(IButton)`
  order: -1;
  color: #fff;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border-radius: 4px;
  height: 40px;
  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 111px;
  `)}

  &:hover:not([disabled]) {
    background-color: #9b7e32;
  }
`;

const LeftButton = styled(IButton)`
  order: 1;
  color: ${props => props.theme.primaryColor};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props => (props.theme.isMobile ? `
    overflow-y: auto;
    width: 100%;
    flex-grow: 2;
  ` : `
    width: 634px;
    height: 300px;
  `)}
`;

const List = styled.ul`
  margin: 0;
  padding: 0;

  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    overflow-y: auto;
    width: 355px;
    height: 267px;
  `)}
`;

const Name = styled.span`
  color: ${props => props.theme.bodyColor};
  font: ${props => props.theme.fontWeightBold} 14px/1 ${props => props.theme.fontFamilyBody};
`;

const Line = styled.li`
  display: flex;
  align-items: center;
  border-radius: 3px;
  height: 35px;
  padding: 0 5px;

  ${props => (props.selected && `
    background-color: #f7f9fa;
  `)}

  &:hover {
    background-color: ${props => props.theme.secondaryColorLight};
  }
`;

const Error = styled.p`
  margin: 0;
  margin-top: 20px;
  color: ${props => props.theme.errorColor};
  font: ${props => props.theme.fontWeightBold} 11px/13px ${props => props.theme.fontFamilyBody};
  text-align: left;
`;

export {
  Container,
  ContainerAlt,
  Content,
  Description,
  Error,
  Footer,
  LeftButton,
  Line,
  List,
  Name,
  RightButton,
  Title,
};
